import { apiPath } from './apiPath';
import app from './appClient';

export const addNewWorkerBioData = (addressData) => app.post(apiPath.addWorker, addressData);
export const editPartnerWorkerBioDataAPI = (addressData) => app.post(apiPath.editPartnerWorkerBioData, addressData);
export const getPartnerWorkerStatusAPI = (params) => app.get(apiPath.getPartnerWorkerStatus, {params});
export const partnerWorkerChangeStatusAPI = (addressData) => app.post(apiPath.partnerWorkerChangeStatus, addressData);
export const getPartnerWorkerListAPI = (addressData) => app.post(apiPath.partnerWorkerList, addressData);
export const saveNewWorkerProcessingData = (addressData) => app.post(apiPath.saveWorkerProcessingData, addressData);
export const partnerWorkerProfileStatusesAPI = (params) => app.get(apiPath.partnerWorkerProfileStatuses, {params});
export const partnerSendRegLinkAPI = (payload) => app.post(apiPath.partnerSendRegLink, payload);